Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $(".x-address-list"), wrapper;

    if ($wrapper.length < 1) return;

    wrapper = $wrapper.get(0);

    var addressType = $wrapper.data('address-type');
    var addressGroupFilter = LhApp.Function.QueryString.getValueOf('group');
    var model = null, addressObj = {}, $fancyboxDeleteLink;

    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.update = function () {

        model.Configs.IsShipping = addressType === 'shipping' ? true : false;
        model.Configs.ShippingAddressesPermissions = {};
        model.Configs.ShippingAddressesPermissions.Insert = $wrapper.data('insert');
        model.Configs.ShippingAddressesPermissions.Update = $wrapper.data('update');
        model.Configs.ShippingAddressesPermissions.Delete = $wrapper.data('delete');

        var html = Vendd.Handlebars.parse("accountAddressList_A", model);
        $wrapper.html(html);

        addressGroupFilter = model.AddressGroupFilter;
        $('.js-address-filter', $wrapper).val(addressGroupFilter);

        if (history.pushState) {
            var title = jQuery(document).find('title').text();
            var url = LhApp.Function.Url.setParameterValue("group", addressGroupFilter);
            history.replaceState({}, title, url);
        }

        wrapper.initConfirmation();

        wrapper.loading(false);
    };

    wrapper.initConfirmation = function () {
        $fancyboxDeleteLink = $('.delete-confirmation-fancybox');
        $fancyboxDeleteLink.fancybox({ type: 'inline' });

        $('[data-click="delete-accept"]').on('click', function (e) {
            e.preventDefault();

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Account.Messages.DeleteAddress(addressObj.id, addressObj.type));
            Vendd.MessageBus.subscribe(Vendd.Account.Messages.DeleteAddressSuccess, wrapper, function (envelope) {
                //reset obj
                addressObj = {};
                //close fancybox
                $.fancybox.close();
            });
        });

        $('[data-click="delete-decline"]').on('click', function (e) {
            e.preventDefault();

            //reset obj
            addressObj = {};
            //close fancybox
            $.fancybox.close();
        });
    };

    $wrapper.on('click', '.js-isdefault-address-checkbox', function (e) {
        var $address = $(this).closest('.x-address-box');

        var type = $address.data('address-type');
        var id = $address.data('address-id');

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Account.Messages.SetDefaultAddress(id, type));
    });

    $wrapper.on('click', '.js-address-delete', function (e) {
        var $address = $(this).closest('.x-address-box');

        addressObj = {
            type: $address.data('address-type'),
            id: $address.data('address-id')
        };
        //open fancybox with confirmation
        $fancyboxDeleteLink.trigger('click');
    });

    $wrapper.on('click', '.js-address-edit', function (e) {

        var $address = $(this).closest('.x-address-box');

        var type = $address.data('address-type');
        var id = $address.data('address-id');

        var addressModel = _.clone(_.find(model.Addresses, function (address) { return id == address.Id; }));
        var userModel = Vendd.User && Vendd.User.GetClientModel();

        $.extend(addressModel, {
            Literals: model.Literals,
            Configs: model.Configs,
            IsShippingRestrictedToResolvedCountry: model.Configs.IsShippingRestrictedToResolvedCountry,
            IsShipping: type === 'shipping',
            IsBilling: type === 'billing'
        });

        if (type === 'billing') { 
            addressModel.IsReceiptEnabled = userModel.IsB2BUser && model.IsInvoiceEnabled && !model.IsReceiptEnabledForB2B ? false : true;
            addressModel.IsInvoice = addressModel.IsReceiptEnabled ? addressModel.IsInvoice : true;
        }

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Account.Messages.OpenAddressEditForm(addressModel));

        return false;
    });

    $wrapper.on('click', '.js-new-address-add', function () {

        var newAddressModel = Vendd.Account.GetNewAddress(model);
        var userModel = Vendd.User && Vendd.User.GetClientModel();

        $.extend(newAddressModel, {
            Literals: model.Literals,
            Configs: model.Configs,
            IsShipping: addressType === 'shipping',
            IsBilling: addressType === 'billing',
            GroupId: $('.js-address-filter', $wrapper).val()
        });

        if (addressType === 'billing') {
            newAddressModel.IsReceiptEnabled = userModel.IsB2BUser && model.IsInvoiceEnabled && !model.IsReceiptEnabledForB2B ? false : true;
            newAddressModel.IsInvoice = newAddressModel.IsReceiptEnabled ? newAddressModel.IsInvoice : true;
        }

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Account.Messages.OpenAddressEditForm(newAddressModel));

        return false;

    });

    $wrapper.on('change', '.js-address-filter', function () {
        addressGroupFilter = $(this).val();
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Account.Messages.GetAddresses(addressType, addressGroupFilter));
    });

    wrapper.loading(true);

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAddressesSuccess, wrapper, function (envelope) {
        model = envelope.message.data;

        wrapper.update();
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.AddressModelChanged, wrapper, function (envelope) {

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Account.Messages.GetAddresses(addressType));
    });

    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Account.Messages.GetAddresses(addressType, addressGroupFilter));

});